import { z } from 'zod';

// ─── WiFi AP (migrated from @ledium/types) ───────────────────────────────────

export const WIFI_AP_SSID_REGEX = /^[A-Za-z0-9_ .-]{1,32}$/;
export const WIFI_AP_PASSPHRASE_REGEX = /^[A-Za-z0-9_ !@#$%^*()+={},.:;-]{8,63}$/;

export const isValidSsid = (v: string) => WIFI_AP_SSID_REGEX.test(v);
export const isValidPassphrase = (v: string) => WIFI_AP_PASSPHRASE_REGEX.test(v);

// ─── Spectral ─────────────────────────────────────────────────────────────────

export const spectralRangesSchema = z.object({
    uvC: z.number(),
    uvB: z.number(),
    uvA: z.number(),
    uv: z.number(),
    blue: z.number(),
    green: z.number(),
    red: z.number(),
    fr: z.number(),
    ir: z.number(),
    sum: z.number(),
    visibleSum: z.number()
});

export const spectrogramPointSchema = z.object({
    waveLength: z.number(),
    irradiance: z.number(),
    pfd: z.number()
});

export const csvDataPointSchema = z.object({
    waveLength: z.number(),
    value: z.number()
});

export const spectrogramRangesSchema = z.object({
    pfd: spectralRangesSchema,
    irradiance: spectralRangesSchema
});

// ─── DMX ──────────────────────────────────────────────────────────────────────

export const DMX_RESOLUTIONS = [1, 8, 16, 24, 32] as const;
export const dmxResolutionSchema = z.union([z.literal(1), z.literal(8), z.literal(16), z.literal(24), z.literal(32)]);

export const CHANNEL_MIN = 1;
export const CHANNEL_MAX = 512;

// ─── Common fields ────────────────────────────────────────────────────────────

export const NAME_MAX_LENGTH = 255;
export const DESCRIPTION_MAX_LENGTH = 1000;

export const nameSchema = z.string().min(1).max(NAME_MAX_LENGTH);
export const descriptionSchema = z.string().max(DESCRIPTION_MAX_LENGTH);
export const idRefSchema = z.string().min(1);
